import { gql } from '@provision/graphql-client';

export const GET_USER_PRESENCE_QUERY = gql`
  query GetUserPresence($params: GetUserPresenceInput!) {
    getUserPresence(params: $params) {
      ts
      items {
        __typename
        userId
        assigneeGroups {
          id
          name
        }
        tz
        status
        lastSeen
        expiresAt
      }
    }
  }
`;

export const UPDATE_USER_PRESENCE_MUTATION = gql`
  mutation UpdateUserPresence($params: UpdateUserPresenceInput!) {
    updateUserPresence(params: $params) {
      success
    }
  }
`;
